/***
 *
 *   ONBOARDING LAYOUT
 *   Simple layout to focus on user onboarding actions
 *
 **********/

import { type ComponentType } from 'react';
import Style from './onboarding.tailwind.js';

interface OnboardingLayoutProps {
  children: ComponentType<Record<string, unknown>>;
  data?: Record<string, unknown>;
}

export function OnboardingLayout(props: OnboardingLayoutProps) {
  return <main className={Style.onboarding}>{<props.children {...props.data} />}</main>;
}
